export default __webpack_public_path__ + "static/media/zonaexpo_pnsv2022.59ac5ef4.jpg";